import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import { connect } from 'react-redux';
import { buildPhonesSelector } from 'store/selectors/memberPhones.selector';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

function MemberPhone({ memberPhone, handleEdit })
{
    return (
        <div className="tw-flex odd:tw-bg-primary-lightest dark:odd:tw-bg-zinc-800 tw-py-3 tw-px-1 tw-items-center tw-text-[#808080] dark:tw-text-[#C9C9C9]">
            <div className="tw-w-[200px] tw-pr-3 ">
                <p>{memberPhone.display_phone}</p>
            </div>
            <div className="tw-w-[50px]">
                {handleEdit
                    && (
                        <Button
                            icon={faEdit}
                            onClick={handleEdit}
                            margin="tw-mt-0 tw-py-0 tw-px-0 tw-mx-0"
                            type="custom"
                            customBg="tw-bg-transparent tw-text-primary-default hover:tw-text-primary-hover"
                            className="tw-self-center"
                            iconClassName="tw-mr-0 tw-text-lg"
                        />
                    )}
            </div>
        </div>
    );
}

MemberPhone.propTypes = {
    memberPhone: PropTypes.shape({
        id: PropTypes.number,
        display_phone: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    handleEdit: PropTypes.func,
};

const mapStateToProps = () =>
{
    const memberPhoneSelector = buildPhonesSelector();

    return (state, props) => ({
        memberPhone: memberPhoneSelector(state, props.memberPhoneId),
    });
};

export default connect(mapStateToProps)(MemberPhone);
